const GeneralLangKey = [
	'btn_filters_apply',
	'react_select_placeholder',
	'react_select_no_options',
	'react_select_create_label',
	'header_language_label',
	'total_label',
	'table_no_data'
] as const

type IGeneralLangKey = typeof GeneralLangKey[number]

export type IGeneralLang = {
	general: Record<IGeneralLangKey, string>
}

const langEntries = GeneralLangKey.map(
	(key: IGeneralLangKey) => [key, `general.${key}`]
)

const langObj: Record<IGeneralLangKey, string> = Object.fromEntries(langEntries)

export const GENERAL_LANG_KEY: IGeneralLang = {
	general: langObj
}